import React from 'react';
import GoogleLogin from '../../components/GoogleLogin';
import logo from 'url:../../static/images/na-logo-dark-small.png';
import './styles.scss';

const Login = () => {

  return (
    <div className="login-container">
      <div className="login-wrapper">
        <div className="login-logo-wrapper">
          <img src={logo} className="login-logo" alt="logo"/>
          <h1 className="login-title">
            Conductor
          </h1>
        </div>

        <GoogleLogin/>
      </div>
    </div>
  )
};

export default Login;
